<template>
  <v-card
    class="c-slide-control-prev"
    color="transparent"
    flat
    ripple
    @click.stop="handleClick"
  >
    <v-btn fab depressed small color="grey lighten-2">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit('prev')
    },
  },
}
</script>

<style lang="scss">
.c-slide-control-prev {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  cursor: pointer;
}
</style>
